import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { AngularDirective } from '../../common/react/components/AngularDirective';
import { IOmniboxExternalScope } from '../../ts/controllers/OmniboxCtrl';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { MousedownOutsideDetector } from '../../ts/helpers/MousedownOutsideDetector';

export class HeaderSearchBox extends React.Component<HeaderSearchBox.Props, HeaderSearchBox.State> {

  static displayName = 'HeaderSearchBox';

  static element = React.createFactory(HeaderSearchBox);

  static minResultsWidth = 350;

  private static nextId = 1;

  private linkPadding = 15;

  private detachMousedownOutsideDetector: () => void;

  public render() {
    const resultsWidth = HeaderSearchBox.minResultsWidth > this.props.omniboxOpenWidth
      ? HeaderSearchBox.minResultsWidth
      : this.props.omniboxOpenWidth;

    const content = AngularDirective.element({
      angularContext: this.props.angularContext,
      setupScope: (scope: ng.IScope) => {
        const omniboxScope = <IOmniboxExternalScope>scope.$new();
        omniboxScope.closed = (event: BaseJQueryEventObject) => this.props.searchClosed(event);
        omniboxScope.isSearchOpen = this.props.isSearchOpen;
        return omniboxScope;
      },
      template: `<tb:omnibox width="${resultsWidth}" search-open="${this.props.isSearchOpen}" closed="closed(event)"></tb:omnibox>`
    });
    return React.createElement('div', {
      ref: 'omniboxSearchOpen',
      style: {
        marginLeft: this.linkPadding,
        width: this.props.omniboxOpenWidth+'px'
      }
    }, content);
  }

  public componentDidMount() {
    const id = ''+HeaderSearchBox.nextId++;
    this.detachMousedownOutsideDetector = MousedownOutsideDetector.attach(
      $(ReactDOM.findDOMNode(this)),
      (element: JQuery) => id,
      (downEvent: JQueryMouseEventObject) => this.props.searchClosed(downEvent));
  }

  public componentWillUnmount() {
    this.detachMousedownOutsideDetector();
  }

}

export module HeaderSearchBox {

  export interface Props extends ReactDirectiveProps {
    omniboxOpenWidth: number;
    searchClosed: (event: BaseJQueryEventObject) => void;
    isSearchOpen: boolean;
  }

  export interface State {
  }

}
